'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Immutable = require('Immutable');

var _BookingFormField = require('./BookingFormField');

var _BookingFormField2 = _interopRequireDefault(_BookingFormField);

var _propertyTranslator = require('property-translator/propertyTranslator');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var displayName = 'CustomFormInputs';

var propTypes = {
  formFields: _react.PropTypes.instanceOf(_Immutable.List).isRequired,
  customFormFields: _react.PropTypes.instanceOf(_Immutable.Map).isRequired,
  onCustomFormFieldChange: _react.PropTypes.func.isRequired,
  formStateValidation: _react.PropTypes.instanceOf(_Immutable.Map).isRequired
};

var CustomFormInputs = function CustomFormInputs(_ref) {
  var formFields = _ref.formFields,
      customFormFields = _ref.customFormFields,
      onCustomFormFieldChange = _ref.onCustomFormFieldChange,
      formStateValidation = _ref.formStateValidation;
  return _react2.default.createElement(
    'div',
    { style: { wordWrap: 'break-word' } },
    formFields.map(function (field) {
      return _react2.default.createElement(_BookingFormField2.default, {
        fieldValue: customFormFields.get(field.name),
        fieldName: field.name,
        validation: formStateValidation.get(field.name),
        setFormValue: onCustomFormFieldChange,
        type: field.type,
        fieldType: field.fieldType,
        isRequired: field.isRequired,
        fieldLabel: (0, _propertyTranslator.propertyLabelTranslator)(field.label),
        fieldOptions: field.options,
        fieldIsCustom: field.isCustom,
        key: '' + field.name
      });
    })
  );
};

CustomFormInputs.displayName = displayName;
CustomFormInputs.propTypes = propTypes;

exports.default = CustomFormInputs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/input/CustomFormInputs.js
// module id = 483
// module chunks = 0